export const LANGUAGES = {
    LT: "lt-LT",
    EN: "en-GB"
}